import { CurrencyParts } from '../../core/models/interfaces/currency-parts';

export function getCurrencyParts(value: number): CurrencyParts {
  let response = <CurrencyParts>{};

  if (value == null || value == 0) {
    response.entire = '0';
    response.decimal = '00';
  } else {
    let [currencyInt, currencyDec] = value.toFixed(2).split('.');
    response.entire = currencyInt;
    response.decimal = currencyDec;
  }

  return response;
}

/**
 * Converts currency string to number
 * Ej: $100.000,00 -> 100000.00
 * @param currency $100.000,00
 */
export function currencyToNumber(currency: string) {
  let number = 0;
  if (currency != null) {
    let numberString = currency.replace(/\$/g, '').replace(/\./g, '');
    let numberParts = numberString.split(',');
    number = Number(numberParts.join('.'));
  }
  return number;
}

/**
 * Converts a number to a string number with a comma as decimal separator
 * Ready to go to the currency input. The mask will take care of the rest.
 * E: 1000.55 -> "1000,55"
 * @param amountNumber Ej: 1000.55
 */
export function numberToCurrency(amountNumber: number): string {
  let amountString: string = amountNumber.toFixed(2);

  amountString = '$' + amountString.replace(/\./g, ',');

  return amountString;
}

//string numbers. This can be used with inputs type "tel"

/**
 * Converts a clean value string number to another string number with comma and $
 * Example: cleanValue = 15000   =>  currencyValue = $150,00
 * @param cleanValue String number without commas
 */
export function getCurrencyValue(cleanValue: string): string {
  let curencyValue: string;
  //pad to 3 places
  curencyValue = pad(cleanValue, 3);
  //add a comma in the third place from right to left
  let entire = curencyValue.slice(0, -2);
  // "entire" its transformed into a Number to add points every 3 positions
  entire = parseInt(entire).toLocaleString('de-DE');
  let decimal = curencyValue.slice(-2);
  curencyValue = '$' + entire + ',' + decimal;

  return curencyValue;
}

/**
 * Pad a string number with leading zeros
 * @param num clean string number ex: 1500
 * @param size Number of minimum final places
 */
export function pad(num: string, size: number): string {
  let s = num + '';
  while (s.length < size) s = '0' + s;
  return s;
}

/**
 * get a clean string number from a dirty string like a currency string
 * example: $1500,00  =>  150000
 * @param value dirty string number ex: $1500,00
 */
export function getCleanStringNumber(value: string) {
  var regNumbers = /[^0-9]/gi;
  var regLeadingZeros = /^0+/gi;

  //get only numbers
  let cleanStringNumber: string = value.replace(regNumbers, '').replace(regLeadingZeros, '');

  return cleanStringNumber;
}
